import React from 'react';
import { connect } from 'react-redux';
import { List, ListItem, Divider, Paper, FontIcon } from 'material-ui';
import SingleProductPreview from './single-product-preview';
import R from 'ramda';
const propTypes = {
  convertedContract: React.PropTypes.array,
  contract: React.PropTypes.object,
  updateWithKeyPath: React.PropTypes.func,
  sendMsg: React.PropTypes.func,
  exportContract: React.PropTypes.func,
  editCarriesTo: React.PropTypes.string,
  checkIfDupeRateNameExistsWithinADateRange: React.PropTypes.func,
};
class ExportContentPreview extends React.Component {
  constructor() {
    super();
    this.state = { selectedIndex: 0 };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== React.PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { convertedContract, updateWithKeyPath, sendMsg, editCarriesTo, checkIfDupeRateNameExistsWithinADateRange } = this.props;
    if (!(convertedContract && convertedContract.length)) return <div/>;
    const { selectedIndex } = this.state;
    const productToDisplay = convertedContract[selectedIndex];
    const ifDupeRateNameExistsAtAll = product => product.forTourplan.some(({ DateRange }) => checkIfDupeRateNameExistsWithinADateRange(DateRange));
    return (
      <Paper style={{ display: 'flex', marginTop: '8px' }}>
        <List
          style={{ width: '15%', padding: '0' }}
        >
          {
            convertedContract.map((product, index) => (
              <div key={index}>
                <ListItem
                  style={selectedIndex === index ? { backgroundColor: '#e0e0e0' } : {}}
                  primaryText={<span style={{ display: 'flex', alignItems: 'center', wordBreak: 'break-word' }}>
                    {product.tourplanName} ({product.mapping})
                    {ifDupeRateNameExistsAtAll(product) ? <FontIcon className="tc-icon-report" style={{ color: 'red', marginLeft: '4px' }}/> : <span/>}
                  </span>}
                  onTouchTap={() => this.setState({ selectedIndex: index })}
                />
                <Divider/>
              </div>
            ))
          }
        </List>
        <div style={{ width: '85%', borderLeft: '1px solid #e0e0e0', padding: '0 4px 4px 4px' }}>
          <SingleProductPreview
            {...productToDisplay}
            checkIfDupeRateNameExistsWithinADateRange={checkIfDupeRateNameExistsWithinADateRange}
            convertedContract={convertedContract}
            editCarriesTo={editCarriesTo}
            sendMsg={() => sendMsg(['convertedContract', selectedIndex], productToDisplay.historyFeedId, productToDisplay.discrepancyMsg)}
            updateWithKeyPath={updateWithKeyPath}
            updateThisProductWithKeyPath={(path, val) => updateWithKeyPath(R.concat(['convertedContract', selectedIndex], path), val)}
          />
        </div>
      </Paper>
    );
  }
}
ExportContentPreview.propTypes = propTypes;
const mapStateToProps = ({ integration }) => ({
  editCarriesTo: integration.toJS().editCarriesTo,
  contract: integration.toJS().contract,
  convertedContract: integration.get('convertedContract') ? integration.get('convertedContract').toJS() : [],
});

export default connect(mapStateToProps)(ExportContentPreview);



// WEBPACK FOOTER //
// ./src/app/components/integration/export/export-content-preview/container.jsx